import { render } from "./TemporaryLogin.vue?vue&type=template&id=1e80b371&scoped=true"
import script from "./TemporaryLogin.vue?vue&type=script&lang=js"
export * from "./TemporaryLogin.vue?vue&type=script&lang=js"

import "./TemporaryLogin.vue?vue&type=style&index=0&id=1e80b371&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e80b371"]])

export default __exports__